export default __webpack_public_path__ + "static/media/Pass.4240542b.png";